module.exports = __webpack_public_path__ + "img/Comparison.e4c39d9d.svg";